<div class="card ticket-transfer-panel-body mb-4 rounded">
  <ng-container *ngIf="pastGame === false">
    <fgbcl-ticket-transfer-window-status-bar
      [windowStartDate]="customerTicketSummary.WindowStartDate"
      [windowEndDate]="customerTicketSummary.WindowEndDate"
      [availableTransfers]="availableTransfers"
    ></fgbcl-ticket-transfer-window-status-bar>
  </ng-container>
  <div class="card-body text-center ticket-transfer-game-panel-details">
    <div class="ticket-transfer-game-details">
      <div class="team-info">
        @if (customerTicketSummary.HomeTeamId < 0) {
          <fgbcl-shield-icon></fgbcl-shield-icon>
        } @else {
          <img [src]="homeTeamLogoUrl" alt="" class="team-icon" />
        }
        <span class="team-name">{{ customerTicketSummary.TeamNames?.HomeTeamName }}</span>
      </div>
      <div class="game-date">
        <span class="game-day">{{ customerTicketSummary.Date | date: 'd MMM y' }}</span>
        <span class="game-time">{{ customerTicketSummary.Date | date: ' HH:mm' }}</span>
      </div>
      <div class="team-info">
        @if (customerTicketSummary.AwayTeamId < 0) {
          <fgbcl-shield-icon></fgbcl-shield-icon>
        } @else {
          <img [src]="awayTeamLogoUrl" alt="" class="team-icon" />
        }
        <span class="team-name">{{ customerTicketSummary.TeamNames?.AwayTeamName }}</span>
      </div>
    </div>
    <div class="ticket-transfer-ticket-info">
      <div class="ticket-transfer-game-panel-tickets-details">
        <div class="tickets-owned">
          <span class="ticket-count" *ngIf="availableTransfers">{{ ticketDetails.TicketsAvailableToTransfer }}</span>
          <span class="ticket-count" *ngIf="!availableTransfers">{{ customerTicketSummary.TotalAmountOfTickets }}</span>
          <span class="ticket-label">{{ 'fgbcl.ticket.transfer.game.panel.my.tickets' | translate }}</span>
        </div>
        <div class="ticket-transferred">
          <span class="ticket-count">{{ ticketDetails.TicketsTransferred }}</span>
          <span class="ticket-label">{{ 'fgbcl.ticket.transfer.game.panel.tickets.transferred' | translate }}</span>
        </div>
      </div>
    </div>
    @if (!pastGame) {
      <button class="ticket-transfer-panel-select-game" (click)="selectGame(customerTicketSummary)">
        {{ 'fgbcl.ticket.transfer.game.panel.select.button.text' | translate }}
      </button>
    } @else {
      <button class="ticket-transfer-panel-view-game" (click)="selectGame(customerTicketSummary)">
        {{ 'fgbcl.ticket.transfer.game.panel.view.button.text' | translate }}
      </button>
    }
  </div>
</div>
